import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../shared/toast/toast.component';
import { OrganizationService } from '../services/organization.service';
import { Organization } from '../shared/models/organization.model';
import { ee, perPage100 } from '../shared/constants';
import { removeTooltipElement } from '../shared/functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss'],
  standalone: false
})
export class OrganizationsComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private organizationService = inject(OrganizationService);


  isLoading = {
    organizations: true,
  };
  isSearching = false;
  perPage = perPage100;
  // Filters
  name = '';
  politician = '';
  notes = '';
  // Arrays
  organizations: Organization[] = [];
  organizationAdded = false;
  count = 0;
  page = 0;
  currentContent = 'organizations';
  menuItems = [
    { name: 'Third parties', link: 'organizations', icon: 'building' },
    { name: '', link: '', icon: '' }, // Workaround to create a separator
    { name: 'Add new', link: 'add-new-organization', icon: 'plus-circle' },
  ];

  ngOnInit(): void {
    ee.on('changeContent', (data: string) => {
      this.currentContent = data;
      this.organizationAdded = false;
    });
    ee.on('setPoliticianFilter', (politician: any) => {
      this.politician = politician;
      this.search();
    });
    ee.on('getOrganizations', () => this.search());
    ee.on('organizationAdded', (organizationAdded: boolean) => this.organizationAdded = organizationAdded);
    this.search();
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    ee.off('setPoliticianFilter', () => {});
    ee.off('getOrganizations', () => {});
    ee.off('organizationAdded', () => {});
    removeTooltipElement();
  }

  search(page?: number): void {
    this.isLoading.organizations = true;
    this.isSearching = true;
    this.page = page || 0;
    const params = {
      name: this.name,
      _politicians: this.politician,
      notes: this.notes,
      page: this.page,
      perPage: this.perPage,
    };
    this.organizationService.search(params)
      .pipe(finalize(() => this.isLoading.organizations = false))
      .subscribe({
        next: res => {
          this.organizations = res.results;
          this.count = res.count;
        },
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  addAnotherOrganization(): void {
    this.organizationAdded = false;
  }

}
